import { useSelector } from "react-redux";
import { Divider, Text, useColorMode } from "theme-ui";
import MyTeam from "./Dashboard/MyTeam";

const DashboardNew = () => {
    const { generalTimeTracking } = useSelector((state: any) => state.project);
    const [colorMode] = useColorMode();
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#453521" : "#dadada";
    return (
        <div className="main-content" >
            <div className="row" >
                <div className='col-12 col-md-6 col-xl-6 mt-5 mt-xl-0'>
                    <Text className="px-2 ms-3" variant='Poppins36Normal35lh' sx={{ color: titleHeader }}>
                        {'Dashboard V2'}
                    </Text>
                </div>
            </div>
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <div className="row" style={{ backgroundColor: colorMode === 'light' ? '#f7efe5' : '#20283c' }}>
                {/* <div className="col-xl-4">
                    <GeneralTimerHistory />

                </div> */}
                <div className="col-xl-4">
                    <MyTeam />

                </div>
            </div>


        </div>
    )
}

export default DashboardNew